"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const styles_1 = __importDefault(require("../../styles/styles"));
const input_1 = __importStar(require("../input/input"));
const text_1 = __importStar(require("../text/text"));
const QuestionManager = ({ survey_question, answer, setAnswer }) => {
    let questionElement = react_1.default.createElement(react_native_1.View, null);
    /* eslint indent: [2, 4, {"SwitchCase": 1}] */
    switch (survey_question.question_type) {
        case 0:
            questionElement = (react_1.default.createElement(react_native_1.View, { style: styles_1.default.flexOne },
                react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_TITLE }, survey_question.question),
                react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexOne, { width: '85%', alignSelf: 'center' }] },
                    react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_SLIDER, minimumValue: survey_question.minimum_score, maximumValue: survey_question.maximum_score, value: answer, setValue: setAnswer, symbol: "", step: 1, error: "" }))));
            break;
        default:
            questionElement = react_1.default.createElement(react_native_1.View, null);
    }
    return questionElement;
};
exports.default = QuestionManager;
